import React from 'react'
import { Link } from 'react-router-dom'
const ImgTopCard = (props) => {
    return (
        <div className="card mb-5 bg-white rounded">
            <div className="img-animation">
                <img src={props.img} className="card-img-top" alt="..." />
            </div>

            <div className="card-body">
                <h5 className="card-title">{props.title}</h5>
                <p className="card-text">{props.p}</p>
                <Link to={props.link} className="btn custom-btn">{props.linkTitle}
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </Link>
            </div>
        </div>
    )
}
export default ImgTopCard